import { create } from 'zustand';

import { createPortalSlice, type PortalSlice } from '@air/primitive-portal/createPortalSlice';

export type WorkspaceSelectionBarState = PortalSlice;

export const useWorkspaceSelectionBarStore = create<WorkspaceSelectionBarState>()((...args) => ({
  ...createPortalSlice({ portal: null })(...args),
}));
